import { supabase } from '../../lib/supabase';
import type { Applicant } from '../../types/applicant';

export const supabaseApplicantService = {
  getAll: async () => {
    const { data, error } = await supabase
      .from('applicants')
      .select(`
        appl_id,
        appl_name,
        appl_cont_name,
        appl_phone,
        appl_email,
        appl_abbr
      `)
      .order('appl_id', { ascending: false });

    if (error) {
      console.error('Error fetching applicants:', error);
      throw error;
    }

    return data;
  },

  getById: async (id: number) => {
    const { data, error } = await supabase
      .from('applicants')
      .select(`
        appl_id,
        appl_name,
        appl_cont_name,
        appl_phone,
        appl_email,
        appl_abbr
      `)
      .eq('appl_id', id)
      .single();

    if (error) throw error;
    return data;
  },

  create: async (applicant: Omit<Applicant, 'appl_id'>) => {
    const { data, error } = await supabase
      .from('applicants')
      .insert([applicant])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  update: async (id: number, updates: Partial<Omit<Applicant, 'appl_id'>>) => {
    const { data, error } = await supabase
      .from('applicants')
      .update(updates)
      .eq('appl_id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  delete: async (id: number) => {
    const { error } = await supabase
      .from('applicants')
      .delete()
      .eq('appl_id', id);

    if (error) throw error;
  }
};
